import { IDirectionWorldMarker } from 'react-give-me-map';
import { CtxEdit } from 'session/ctxEdit';

import 'components/site/general/singleSelect/SelectedMarkerV2/style.css';
import { useContext, useEffect, useState } from 'react';

import { DragPoints } from 'components/site/general/singleSelect/SelectedMarkerV2/DragPoints';
import { SelectArea } from 'components/site/general/singleSelect/SelectedMarkerV2/SelectedArea';
import 'components/site/general/singleSelect/SelectedMarkerV2/style.css';
import { IXY } from 'react-give-me-map/dist/utils/map/mapTypes';
import { useUpdateEffect } from 'usehooks-ts';

interface Props {
    markerId: string;
}

export const SelectedMarkerV2Route = (props: Props) => {
    const ctxEdit = useContext(CtxEdit);

    const marker = ctxEdit.worldMarkers.find(
        (e) => e.id === props.markerId
    ) as IDirectionWorldMarker;

    const coordinates = marker.elementData.coordinates;
    const color = marker.elementData.color;

    const [currentDrag, setCurrentDrag] = useState<'point' | 'map' | null>(null);

    function getInitialXyCoordinates(): IXY[] {
        return coordinates.map((c) => ctxEdit.mapRef.current?.project([c.lng, c.lat]));
    }

    const [xyCoordinates, setXyCoordinates] = useState(() => getInitialXyCoordinates());

    useEffect(() => {
        const onMoveOrZoom = () => {
            setXyCoordinates(getInitialXyCoordinates());
            setCurrentDrag('map');
        };
        const onMoveEndOrZoomEnd = () => {
            setCurrentDrag(null);
        };
        ctxEdit.mapRef.current?.on('move', onMoveOrZoom);
        ctxEdit.mapRef.current?.on('zoom', onMoveOrZoom);
        ctxEdit.mapRef.current?.on('moveend', onMoveEndOrZoomEnd);
        ctxEdit.mapRef.current?.on('zoomend', onMoveEndOrZoomEnd);
        return () => {
            ctxEdit.mapRef.current?.off('move', onMoveOrZoom);
            ctxEdit.mapRef.current?.off('zoom', onMoveOrZoom);
            ctxEdit.mapRef.current?.off('moveend', onMoveEndOrZoomEnd);
            ctxEdit.mapRef.current?.off('zoomend', onMoveEndOrZoomEnd);
        };
    }, [ctxEdit.mapRef.current, coordinates]);

    useUpdateEffect(() => {
        setXyCoordinates(getInitialXyCoordinates());
    }, [marker.elementData.coordinates]);
    return (
        <SelectArea>
            <>
                {(currentDrag === null || currentDrag === 'point') && (
                    <DragPoints
                        disabled
                        xyCoordinates={[xyCoordinates[0], xyCoordinates[xyCoordinates.length - 1]]}
                        color={color}
                    />
                )}
            </>
        </SelectArea>
    );
};
